import MenuItem from "@mui/material/MenuItem";
import { MenuItemProps } from "@mui/material";
import { forwardRef, FC, ReactNode } from "react";

import Box from "../../Box";
import menuItem from "./styles";
import Typography from "../../Typography";

interface IProps extends MenuItemProps {
    title: string;
    icon?: ReactNode;
    maxWidth?: string | number;
    colorText?: "inherit" | "primary" | "secondary" | "info" | "success" | "warning" | "error" | "light" | "dark" | "text" | "white";
}

const CustomMenuItem = forwardRef<HTMLLIElement, IProps>(({ icon, title, colorText, maxWidth, ...rest }, ref) => (
    <MenuItem {...rest} ref={ref} sx={(theme) => menuItem(theme)}>
        <Box py={0} display="flex" alignItems="center" lineHeight={1}>
            {
                icon &&
                <Typography variant="body1" color="secondary" lineHeight={0.75}
                    sx={{ marginRight: "8px" }}>
                    {icon}
                </Typography>
            }
            <Typography color={colorText} variant="button" fontWeight="regular"
                sx={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    maxWidth: maxWidth || "140px",
                }}>
                {title}
            </Typography>
        </Box>
    </MenuItem>
));

export default CustomMenuItem;
